module.exports = __webpack_public_path__ + "images/iphone/mail_button.png";